export default __webpack_public_path__ + "static/media/pvilla1-1.3138f336.jpg";